import React, { useState, useEffect ,useRef } from "react";
import { useForm } from "react-hook-form";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { addContactUs, VerifyCaptcha } from "../../services/InquiryService";
import { toast } from "react-toastify";
import { routes } from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import { injectModels } from "../../redux/injectModels";
import ReCAPTCHA from "react-google-recaptcha";
import { GlobalSettingService } from "../../services";
import { handleConsoleError } from "../../utils/common-methods";

const Inquiry = (props) => {
  const navigate = useNavigate();
   const recaptchaRef = useRef(null);
  const [token, setToken] = useState(null);
  const [captchaError, setCaptchaError] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [captchaKey, setCaptchaKey] = useState("");

  const getCaptchaDetails = async () => {
    try {
      const res = await GlobalSettingService.getRecaptchaDetails();
      if (res?.isSuccess && res?.data) {
        setCaptchaKey(GlobalSettingService.decrypt(res?.data?.keyValue));
      }
    } catch (error) {
       const message= handleConsoleError(error);
       toast.error(error?.message|| message);
    }
  };

  useEffect(() => {
    const bootstrapAsync = async () => {
      await Promise.all([getCaptchaDetails()]);
    };
    bootstrapAsync();
  }, [captchaKey]);

  const onSubmit = async (data) => {
    try {
      if (!token) {
        setCaptchaError("Captcha is required.");
        return;
      }
      setCaptchaError("");
      props.application.setLoading(true);
      const responseReCaptcha = await VerifyCaptcha({
        captchaToken: token,
      });

      if (responseReCaptcha?.isSuccess) {
        //toast.success("Captcha verified");

        const response = await addContactUs(data);
        if (response?.isSuccess) {
          toast.success(response?.message);
          navigate(routes.DEFAULT);
        } else {
          toast.error(response?.message);
            recaptchaRef.current?.reset();
    setToken(null);
        }
      } else {
        toast.error("Recaptch issue");
      }
    } catch (error) {
      const message=handleConsoleError(error)
      toast.error(error?.message || message);
        recaptchaRef.current?.reset();
    setToken(null);
    } finally {
      props.application.setLoading(false);
    }
  };

  return (
    <Container className="">
      {/* <h1 style={{ textAlign: "center" }}>Contact-us(Enquiry)</h1> */}
      <section className="subscription-banner p-0">
        <div className="container">
          <h3>Contact Us</h3>
        </div>
      </section>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-3">
          <Col md={12}>
            <p>
              <b>IMPORTANT:</b> Only complete this form if you are an Organiser.
              All Trader questions need to be made directly through the
              dedicated platform messaging system by contacting each specific
              event organiser with your query. Please note - any trader messages
              made through this contact form will not be acknowledged or replied
              to.
            </p>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="name">
              <Form.Label>
                First Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                {...register("firstName", {
                  required: "First Name is required",
                })}
              />
              {errors?.firstName && (
                <span className="text-danger">{errors?.firstName?.message}</span>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="name">
              <Form.Label>
                Last Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                {...register("lastName", { required: "Last Name is required" })}
              />
              {errors?.lastName && (
                <span className="text-danger">{errors?.lastName?.message}</span>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="phone">
              <Form.Label>
                Contact Number <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                maxLength={15}
                {...register("phone", {
                  required: "Phone Number is required",
                  pattern: {
                    value: /^[0-9]\d{8,14}$/,
                    message: "Invalid phone number",
                  },
                })}
              />
              {errors.phone && (
                <span className="text-danger">{errors.phone?.message}</span>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="email">
              <Form.Label>
                Email <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Invalid email format",
                  },
                })}
              />
              {errors.email && (
                <span className="text-danger">{errors.email?.message}</span>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="description">
              <Form.Label>
                Message <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                {...register("message", { required: "Message is required" })}
              />
              {errors.message && (
                <span className="text-danger">{errors.message?.message}</span>
              )}
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            {captchaKey && (
              <ReCAPTCHA
               ref={recaptchaRef}
                sitekey={captchaKey}
                onChange={(value) => setToken(value)}
              />
            )}
            {captchaError && (
              <span style={{ color: "red" }}>{captchaError}</span>
            )}
          </Col>
        </Row>
  <Row className="mb-3">
    <Col md={12}>
        <p>By submitting this form you agree that we may use your details to respond to your enquiry. For information on how we use and protect your data, please read our <a target="_blank" href="/privacy-policy" style={{textDecoration: "underline"}}>Privacy Policy</a></p>
        </Col>
        </Row>
        
        <Button type="submit" variant="primary" className="w-20">
          Submit
        </Button>
       
      </Form>
    </Container>
  );
};

// export default Inquiry;
export default injectModels(["application"])(Inquiry);
